import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, FormControlLabel, Link as MuiLink } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormGroup from '@material-ui/core/FormGroup'
import Chip from '@material-ui/core/Chip'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { SiRNAProperties } from '../enum'
import { configContext } from '../Sirna'
import { initialState } from '../Reducer'
import ResultSet from './ResultSet'
import InfoIcon from '@material-ui/icons/Info'
import { regex } from '@src/routes/SemiConfigurators/utils/util'

const useStyles = makeStyles((theme: Theme) => ({
  showsearch: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.grey[400],
    margin: theme.spacing(1.5, 0, 0, 0),
  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
  },
  contentWraper: {
    padding: theme.spacing(5, 4, 5, 4),
    backgroundColor: theme.palette.common.white,
  },
  divider: {
    backgroundColor: theme.palette.grey[400],
    height: theme.spacing(15),
    marginTop: theme.spacing(10),
  },
  filter: {
    margin: theme.spacing(4, 0, 2, 0),
    fontSize: theme.typography.pxToRem(14),
  },
  filterVal: {
    margin: theme.spacing(1, 0, 2, 0),
    fontSize: theme.typography.pxToRem(15),
    color: '#b6afaf',
  },
  filterStyle: {
    margin: theme.spacing(1, 0, 2, 0),
    fontSize: theme.typography.pxToRem(15),
  },
  filterValOne: {
    margin: theme.spacing(1, 0, 2, 0),
    fontSize: theme.typography.pxToRem(15),
    color: '#b6afaf',
    paddingLeft: theme.spacing(7),
  },
  divPaddingTop: {
    paddingTop: theme.spacing(7),
  },
  boldText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  InfoPopup: {
    maxWidth: theme.spacing(105),
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    boxShadow: theme.shadows[4],
    padding: theme.spacing(5),
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.common.black,
    borderRadius: '2%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  arrow1: {
    color: theme.palette.common.white,
  },
  InfoIcon: {
    position: 'relative',
    fontSize: theme.typography.pxToRem(16),
    top: theme.spacing(1.0),
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1),
  },
  IconButton: {
    outlined: true,
    padding: theme.spacing(0.4, 1, 1, 1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    verticalAlign: 'middle',
  },
  form: {
    padding: theme.spacing(0, 6, 0, 2),
    flexDirection: 'row',
  },
  fontSize2: {
    fontSize: theme.typography.pxToRem(12),
  },
  formList: {
    padding: theme.spacing(0, 1, 0, 0),
    margin: theme.spacing(0),
    color: theme.palette.grey[300],
  },
  margin: {
    margin: theme.spacing(0, 3, 0, 0),
  },
  searchTerms: {
    paddingTop: theme.spacing(0.5),
  },
  marginLeft: {
    margin: theme.spacing(0.75),
  },
  searchTermPadding: {
    paddingTop: theme.spacing(1),
  },
  linkPadding: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(3),
  },
  noteInfo: {
    padding: theme.spacing(3),
    border: `solid 1px ${theme.palette.primary.main}`,
    borderRadius: theme.typography.pxToRem(5),
    width: 'fit-content',
    borderLeftWidth: 'thick',
  },
}))

const SearchResult = (): JSX.Element => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(configContext)
  const { searchResult, searchInput, geneSearchError } = state
  const url =
    '/technical-documents/technical-article/genomics/gene-expression-and-silencing/predesigned-guarantee'

  const searchResultText = <FormattedMessage {...messages.SEARCH_RESULTS} />
  const filterResult = (
    <FormattedMessage {...messages.CONF_FILTER_RESULT_crisprgrna} />
  )

  const handleChange = (event, keys): void => {
    if (state.stepNo) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
    }

    let speciesArr: string[] = state.searchInput.facet
    if (speciesArr.indexOf(`species:${keys}`) === -1 && keys.length) {
      speciesArr = speciesArr.concat(`species:${keys}`)
      dispatch({
        type: 'UPDATE_CHECK_BOX',
        data: { ...state.checkboxes, [keys]: true },
      })
      dispatch({ type: 'CHECKBOX_UPDATE', data: false })
    } else if (keys.length) {
      speciesArr = speciesArr.filter((item) => item !== `species:${keys}`)
      if (speciesArr.length === 0) {
        speciesArr = speciesArr.concat('species:NONE')
      }
      dispatch({
        type: 'UPDATE_CHECK_BOX',
        data: { ...state.checkboxes, [keys]: false },
      })
      dispatch({ type: 'CHECKBOX_UPDATE', data: true })
    }
    const updateData = { ...state.searchInput, facet: speciesArr, page: 1 }
    dispatch({
      type: 'SEARCH_INPUT',
      data: updateData,
    })
    dispatch({
      type: 'UPDATE_PAGINATION_DATA',
      data: {
        ...state.paginationData,
        page: 1,
      },
    })
    dispatch({
      type: 'UPDATE_TOTAL_PRICE',
      data: '',
    })
    dispatch({
      type: 'UPDATE_SELECTED_DATA',
      data: [],
    })
    dispatch({
      type: 'UPDATE_CHECKED_ALL',
      data: false,
    })
  }

  const handleChipDelete = (data): void => {
    dispatch({ type: 'IS_CHIP_DELETE', data: true })
    if (state.stepNo) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
    }
    let { term } = searchInput
    const myData = term
    term = term
      .replace(term.substr(myData.indexOf(data), data.length), '')
      .replace(/,\s*$/, '')
    dispatch({
      type: 'UPDATE_TOTAL_PRICE',
      data: '',
    })
    dispatch({
      type: 'UPDATE_SELECTED_DATA',
      data: [],
    })
    dispatch({
      type: 'UPDATE_CHECKED_ALL',
      data: false,
    })
    const updateTerm = {
      ...searchInput,
      term: term.trim(),
      page: 1,
    }
    dispatch({
      type: 'SEARCH_INPUT',
      data: updateTerm,
    })
    if (!term.length || term.match(regex)) {
      dispatch({
        type: 'UPDATE_SEARCH_ERROR',
        data: false,
      })
      dispatch({ type: 'IS_CHIP_DELETE', data: false })
      window.scrollTo(0, 0)
      dispatch({
        type: 'SEARCH_INPUT',
        data: initialState.searchInput,
      })
      dispatch({
        type: 'UPDATE_SEARCH_RESULT',
        data: initialState.searchResult,
      })
    }
  }

  const generateChip = () => {
    const { term } = searchInput
    if (term.length) {
      const totalChips = term?.split(/[\s, ]+/)
      const input = [...new Set(totalChips)]
      return input.map((data, index) =>
        data.length > 0 && data ? (
          <Chip
            key={index}
            variant="outlined"
            size="small"
            label={data}
            color="primary"
            onDelete={() => {
              handleChipDelete(data)
            }}
            className={classes.marginLeft}
          />
        ) : (
          ''
        )
      )
    }
    return false
  }

  return (
    <div className={classes.contentWraper}>
      <h2 className={classes.heading}>{searchResultText}</h2>

      {searchResult.count !== 0 &&
      searchInput.term.length > 0 &&
      !geneSearchError ? (
        <div>
          <ResultSet />
        </div>
      ) : (
        ''
      )}

      <Grid container className={classes.searchTermPadding} spacing={1}>
        <Grid item className={classes.margin}>
          <h4 className={classes.searchTerms}>
            <FormattedMessage {...messages.CONF_SEARCH_TERMS} />:
          </h4>
        </Grid>

        <Grid item className={classes.margin}>
          {generateChip()}
        </Grid>
      </Grid>
      <h3 className={classes.filter}>{filterResult}</h3>
      <Grid container spacing={1}>
        <Grid item className={classes.margin}>
          <h4>
            <FormattedMessage {...messages.SEMICONF_SPECIES_siRNA} />:
          </h4>
        </Grid>
        <Grid item className={classes.margin}>
          <FormGroup className={classes.form}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    state.searchInput.facet.indexOf('species:Human') !== -1
                  }
                  onChange={(e) => handleChange(e, SiRNAProperties.Human)}
                  value={SiRNAProperties.Human}
                  color="primary"
                  className={classes.formList}
                />
              }
              label={SiRNAProperties.Human}
              classes={{ label: classes.fontSize2 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    state.searchInput.facet.indexOf('species:Mouse') !== -1
                  }
                  onChange={(e) => handleChange(e, SiRNAProperties.Mouse)}
                  value={SiRNAProperties.Mouse}
                  color="primary"
                  className={classes.formList}
                />
              }
              label={SiRNAProperties.Mouse}
              classes={{ label: classes.fontSize2 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    state.searchInput.facet.indexOf('species:Rat') !== -1
                  }
                  onChange={(e) => handleChange(e, SiRNAProperties.Rat)}
                  value={SiRNAProperties.Rat}
                  color="primary"
                  className={classes.formList}
                />
              }
              label={SiRNAProperties.Rat}
              classes={{ label: classes.fontSize2 }}
            />
          </FormGroup>
        </Grid>
      </Grid>
      <Grid item className={classes.linkPadding}>
        <FormattedMessage {...messages.SEMICONF_INFO_TEXT_sirna} />
        <MuiLink href={url} target="_blank" color="primary">
          <FormattedMessage
            {...messages.SEMICONF_SIGAM_ALDRICH_INFO_TEXT_sirna}
          />
        </MuiLink>
      </Grid>

      <Grid item className={classes.noteInfo}>
        <InfoIcon
          aria-label="info"
          className={classes.InfoIcon}
          color="primary"
        ></InfoIcon>
        <FormattedMessage {...messages.SEMICONF_NOTE_INFO_TEXT_sirna} />
      </Grid>
    </div>
  )
}
export default SearchResult
